var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { MTableCell } from '@material-table/core';
var TableCell = styled(MTableCell)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.MuiTableCell-alignRight > div {\n    margin-left: auto; // material-table\u306EcellEditable\u306Ediv\u3092\u53F3\u5BC4\u305B\u306B\u3059\u308B\n  }\n"], ["\n  &.MuiTableCell-alignRight > div {\n    margin-left: auto; // material-table\u306EcellEditable\u306Ediv\u3092\u53F3\u5BC4\u305B\u306B\u3059\u308B\n  }\n"])));
var Cell = function (_a) {
    var value = _a.value, otherProps = __rest(_a, ["value"]);
    var normalizedValue = typeof value === 'string' && value.trim().length === 0 ? null : value;
    return React.createElement(TableCell, __assign({ value: normalizedValue }, otherProps));
};
export default Cell;
var templateObject_1;
